"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.zipCode = exports.customerInfo = exports.adresses = void 0;
const adresses = {
    addresses: [
        {
            address: 'Rua voluntários da patria',
            number: '3515',
            complement: 'AP 111',
            city: 'Sao Paulo',
            state: 'Sao Paulo',
            village: 'Jardins',
            reference: 'Edificio Brasilia IX',
            zipcode: '02402300',
            phone: '11999299999',
            phone_area_code: '011',
            is_default: false
        },
    ],
};
exports.adresses = adresses;
const customerInfo = {
    name: 'User Test',
    email: 'user_test@gmail.com',
    cpf_cnpj: '795.702.590-00',
    cell_phone: '11999990000',
    birth_date: '27/06/1992',
};
exports.customerInfo = customerInfo;
const zipCode = {
    zipcode: '02402300',
    latitude: '-23.489150',
    longitude: '-46.626411',
};
exports.zipCode = zipCode;
